import React from 'react';
import { Divider } from '../ecosystem';

const HeaderDivider = ({
    isDashboardPage,
    isMobile,
    scrolledPastOffset
}) => {

    const hideDivider = isDashboardPage && isMobile && !scrolledPastOffset;

    return (!hideDivider &&
        <div className="row header__divider">
            <Divider mTop="none" mBottom="none" mLeft="none" mRight="none" />
        </div>
    );
}

export default HeaderDivider;